export { default } from './RemainingTime';
